import type { UserAgentStatusEnum } from "web_myplann/Infrastructure/Api/Api";

export const AdvisorKeys = {
	all: ["advisor"] as const,
	details: () => [...AdvisorKeys.all, "detail"] as const,
	detail: (id: string) => [...AdvisorKeys.details(), id] as const,
	agentDetail: (id: number | undefined) =>
		[...AdvisorKeys.all, "agent", "detail", id ?? null] as const,
	assignedAgentsRoot: () => [...AdvisorKeys.all, "agent", "assigned"] as const,
	assignedAgents: (filterStatus?: UserAgentStatusEnum) =>
		[...AdvisorKeys.assignedAgentsRoot(), { filterStatus }] as const,
	acceptConnection: () => [...AdvisorKeys.all, "acceptConnection"] as const,
};
